import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { IndeterminateCheckBox } from "@material-ui/icons";
const styles = (theme) => ({
  root: {
    padding: 0,
    verticalAlign: "middle",
    height: "100%",
    color: theme.iconColor,
    "&$checked": {
      color: theme.HeaderSelectedText,
    },
    "&$disabled": {
      color: "rgba(0, 0, 0, 0.26)",
    },
  },
  checked: {},
  disabled: {},
  checkbox: {
    fontSize: 24,
  },
  indeterminate: {
    color: theme.iconColor,
  },
});

const CheckboxRenderer = ({ value, classes }) => {
  return (
    <Checkbox
      checked={value.checked}
      icon={<CheckBoxOutlineBlankIcon className={classes.checkbox} />}
      checkedIcon={<CheckBoxIcon className={classes.checkbox} />}
      classes={{
        root: classes.root,
        checked: classes.checked,
        indeterminate: classes.indeterminate,
        disabled: classes.disabled,
      }}
      indeterminateIcon={<IndeterminateCheckBox className={classes.checkbox} />}
      indeterminate={value.isIntermediate}
      disabled={value.disabled}
    />
  );
};

export default withStyles(styles)(CheckboxRenderer);
